import { FAMILY_ROOT_TITLE, PERSONAL_SECTION_LABEL } from '@/lib/blocks/constants';

export type NavSectionKind = 'recents' | 'favorites' | 'family' | 'private';

export const NAV_SECTION_ORDER: NavSectionKind[] = ['recents', 'favorites', 'family', 'private'];

export const NAV_SECTION_IDS: Record<NavSectionKind, string> = {
  recents: 'nav:recents',
  favorites: 'nav:favorites',
  family: 'nav:family',
  private: 'nav:private',
};

export const NAV_SECTION_LABELS: Record<NavSectionKind, string> = {
  recents: 'Recents',
  favorites: 'Favorites',
  family: FAMILY_ROOT_TITLE,
  private: PERSONAL_SECTION_LABEL,
};

export type NavSection = {
  kind: NavSectionKind;
  /** Stable id for expand/collapse persistence (not a block id for recents/favorites). */
  id: string;
  label: string;
  /** Family / Private workspace root block, when available. */
  rootBlockId: string | null;
};

export function buildNavSections(input: {
  familyRootId: string | null;
  privateRootId: string | null;
}): NavSection[] {
  return NAV_SECTION_ORDER.map((kind) => ({
    kind,
    id: NAV_SECTION_IDS[kind],
    label: NAV_SECTION_LABELS[kind],
    rootBlockId:
      kind === 'family' ? input.familyRootId : kind === 'private' ? input.privateRootId : null,
  }));
}
